import styled from 'styled-components';

const TrackingDetailsHeader = styled.div`
  background: var(--luft-primary);
`;

const TrackingDetailsToolbar = styled.div`
  display: flex;
  align-items: flex-start;
  padding: 16px;
  padding-left: 24px;
`;

const HeaderInfoContainer = styled.div`
  && h3 {
    font-size: 24px;
    line-height: 20px;
    font-weight: normal;
    color: white;
    margin-bottom: 22px;
    font-family: 'Work Sans';
    margin-top: 0;
  }
`;

const HeaderInfoWrapper = styled.div`
  display: flex;
  gap: 16px;
`;

const TrackingDetailsToolbarTitle = styled.div`
  flex: 1;
  margin: 0;
  font-size: 24px;
  line-height: 24px;
  font-weight: normal;
  color: white;
`;

const TrackingDetailsCloseModalMobile = styled.div`
  color: white;
  font-size: 18px;
  margin-right: 16px;
  cursor: pointer;
`;

const TrackingDetailsToggleWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-left: 16px;
  color: white;
`;

const TrackingDetailsToggleLabel = styled.div`
  font-size: 14px;
  line-height: 20px;
  white-space: nowrap;
`;

const TrackingDetailTab = styled.div``;

const TrackingDetailsTabs = styled.div`
  background-color: var(--gray-lightest);
  padding: 8px 24px;
`;

const HeaderOrderInfo = styled.div``;
const InfoText = styled.span`
  font-size: 16px;
  line-height: 20px;
  font-family: 'Work Sans';
  font-weight: ${({ title }) => (title ? 'bold' : 'normal')};
  color: white;
  margin-right: 8px;
`;

// -disable-next-line import/prefer-default-export
export const S = {
  TrackingDetailsHeader,
  TrackingDetailsToolbar,
  TrackingDetailsToolbarTitle,
  TrackingDetailsCloseModalMobile,
  TrackingDetailsToggleWrapper,
  TrackingDetailsToggleLabel,
  TrackingDetailTab,
  TrackingDetailsTabs,
  HeaderOrderInfo,
  InfoText,
  HeaderInfoWrapper,
  HeaderInfoContainer,
};
